import { tw } from "@/utils";
import { KtasLevel } from "../types";
import { ktasBgColors } from "@/components/styles";

interface KtasStatusLabelProps {
  ktasLevel: KtasLevel;
}

export const KtasStatusLabel = (props: KtasStatusLabelProps) => {
  const { ktasLevel } = props;

  return (
    <div
      className={tw(
        "flex items-center justify-center gap-[8px]",
        "text-sm font-semibold"
      )}
    >
      <div
        className={tw(ktasBgColors[ktasLevel], "w-[8px] h-[8px] rounded-full")}
      ></div>
      {`Pre-KTAS ${ktasLevel}`}
    </div>
  );
};
